import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { SettingsCard } from "containers/settings/ui";
import FilesTemplateForm from "./files-template-form";

/**
 * The template editor inside the settings layout: files/templates/new creates
 * a template, files/templates/:templateId edits one. Saving or cancelling goes
 * back to the list.
 */
export default function FilesTemplatePage() {
  const { t } = useTranslation();
  const { companyId, templateId } = useParams<{
    companyId: string;
    templateId?: string;
  }>();
  const navigate = useNavigate();

  const listPath = `/app/${companyId}/files/templates`;
  const backToList = () => navigate(listPath);

  return (
    <div className="space-y-4">
      <Link
        to={listPath}
        className="inline-flex items-center gap-1 text-sm font-medium text-indigo-600 hover:text-indigo-800"
      >
        <ArrowLeft aria-hidden className="size-4" />
        {t("settings_templates_back")}
      </Link>
      <SettingsCard
        title={t(templateId ? "settings_templates_edit" : "settings_templates_new")}
      >
        {/* The company is part of the key: the editor is remounted when the company
            changes, so a late answer for the old company cannot fill the new one. */}
        <FilesTemplateForm
          key={`${companyId}/${templateId ?? "new"}`}
          id={templateId}
          onSaved={backToList}
          onCancel={backToList}
        />
      </SettingsCard>
    </div>
  );
}
